import { render, staticRenderFns } from "./AnnouncementOpen.html?vue&type=template&id=2e1c583a&scoped=true&"
import script from "./AnnouncementOpen.vue?vue&type=script&lang=js&"
export * from "./AnnouncementOpen.vue?vue&type=script&lang=js&"
import style0 from "./AnnouncementOpen.scss?vue&type=style&index=0&id=2e1c583a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e1c583a",
  null
  
)

export default component.exports